import type { BrMapping } from '@bloomreach/vue-sdk'

import {
    PlusBlogAuthorPage,
    PlusBlogBloglist,
    PlusBlogBlogpost,
    PlusBlogBreadcrumbs,
    PlusBlogFooter,
    PlusBlogHeader,
    PlusBlogLpOrganismFooter,
    PlusBlogLpOrganismMenu,
    PlusBlogNewsletter,
    PlusBlogRecommendedArticles,
    PlusBlogSwitcher,
    PlusBlogTagPage,
} from '#components'

type TPlusComponentsFlagsKeys = 'isLpHeaderActive' | 'isLpFooterActive'
export type TPlusComponentsFlagsEnv = Record<TPlusComponentsFlagsKeys, string | undefined>

export function plusComponents(flags: TPlusComponentsFlagsEnv): BrMapping {
    return {
        // envToBool doesn't work directly in nuxt.config.ts
        Header: envToBool(flags.isLpHeaderActive) ? PlusBlogLpOrganismMenu : PlusBlogHeader,
        Footer: envToBool(flags.isLpFooterActive) ? PlusBlogLpOrganismFooter : PlusBlogFooter,
        BlogSwitcher: PlusBlogSwitcher,
        RecommendedArticles: PlusBlogRecommendedArticles,
        Bloglist: PlusBlogBloglist,
        Newsletter: PlusBlogNewsletter,
        Blogpost: PlusBlogBlogpost,
        Breadcrumbs: PlusBlogBreadcrumbs,
        Author: PlusBlogAuthorPage,
        Tag: PlusBlogTagPage,
    }
}
